<template>
  <div>
    <iModal
      title="编辑项目"
      v-model="showModal"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
      @on-cancel="cancel"
      style="overflow: auto"
    >
      <div class="project-add">
        <div class="project-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="130"
            @submit.native.prevent
          >
            <FormItem label="展会中文名称：" prop="name">
              <Input
                v-model="formInline.name"
                placeholder="请输入展会中文名称"
              />
            </FormItem>

            <FormItem label="展会英文名称" prop="nameEn">
              <Input
                v-model="formInline.nameEn"
                placeholder="请输入展会英文名称"
              />
            </FormItem>
            <FormItem label="展会简称：" prop="shortName">
              <Input
                v-model="formInline.shortName"
                placeholder="请输入展会简称"
              />
            </FormItem>
            <FormItem label="展会时间：" prop="exdate">
              <DatePicker
                type="datetimerange"
                format="yyyy-MM-dd"
                placeholder="请选择展会时间"
                style="width: 100%"
                v-model="exDate"
                @on-change="dateChange"
              ></DatePicker>
            </FormItem>
            <FormItem label="举办地址：" prop="exHall">
              <Input
                v-model="formInline.exHall"
                placeholder="请输入展会举办地址"
              />
            </FormItem>
            <FormItem label="第三方项目id">
              <Input
                v-model="formInline.projectId"
                placeholder="请输入第三方项目id"
              />
            </FormItem>
            <FormItem label="第三方展会id">
              <Input
                v-model="formInline.thirdPartyExhibitionId"
                placeholder="请输入第三方展会id"
              />
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button
          type="primary"
          :loading="loading"
          @click="handleSubmit('formInline')"
          >确认</Button
        >
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import { provinces } from "@/other/provinces";
import customComponentCommon from "@components/custom-component/custom-component-common.vue";

export default {
  name: "project-add",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    currentId: {
      type: String,
      default: "",
    },
  },
  data() {
    const that = this;
    const typeReg = (rule, value, callback) => {
      if (!that.formInline.type) {
        callback(new Error("请选择展会类型"));
      } else {
        callback();
      }
    };
    const logoReg = (rule, value, callback) => {
      if (that.uploadList && that.uploadList.length) {
        callback();
      } else {
        callback(new Error("请上传展会Logo"));
      }
    };
    const exDateReg = (rule, value, callback) => {
      if (!that.exDate[0] || !that.exDate[1]) {
        callback(new Error("请选择展会时间"));
      } else {
        callback();
      }
    };
    return {
      AgentId: "CD4E8CEF-C6F7-4E72-9132-93161B9E8C43",
      loading: false,
      showModal: false,
      time: [],
      formInline: {
        name: "", // 展会全称
        nameEn: "",
        shortName: "",
        exHall: "", // 举办场馆
        projectId: "",
        thirdPartyExhibitionId: "",
      },
      ruleInline: {
        name: [{ required: true, message: "请输入展会全称", trigger: "blur" }],
        exdate: [{ required: true, validator: exDateReg, trigger: "change" }],
        exHall: [
          { required: true, message: "请输入举办地点", trigger: "blur" },
        ],
      },
      uploadList: [], // 展会logo
      defaultList: [],
      imgName: "",
      visible: false,
      exDate: [], // 展会时间
      provinceArr: [],
      citiesArr: [],
    };
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    },
    currentId(val, old) {
      this.getDetails();
    },
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
    }),
  },
  async created() {
    // this.provinceArr = provinces.data;
  },
  methods: {
    ...mapActions({
      exhibitionIdCurrent: "hostSetModule/exhibitionIdCurrent",
      exhibitionIdPut: "hostSetModule/exhibitionIdPut",
    }),
    // 查看上传图片
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    changModal($event) {
      this.formInline.introduction = $event;
    },
    async getDetails() {
      let res = await this.exhibitionIdCurrent({ id: this.currentId });
      console.log(res, 1111);
      this.formInline = Object.assign({}, res);
      this.exDate = [this.formInline.startTime, this.formInline.endTime];
    },
    async handleSubmit(name) {
      let valid = await this.validForm(name);
      if (!valid) return;

      let startTime = "";
      let endTime = "";
      if (!this.exDate[0] || !this.exDate[1]) {
        this.$Message.warning("请选择展会时间");
        return;
      } else {
        startTime = this.exDate[0];
        endTime = this.exDate[1];
      }

      let req = {
        body: {
          name: this.formInline.name,
          startTime: startTime,
          endTime: endTime,
          nameEn: this.formInline.nameEn,
          shortName: this.formInline.shortName,
          projectId: this.formInline.projectId,
          thirdPartyExhibitionId: this.formInline.thirdPartyExhibitionId,
          exHall: this.formInline.exHall,
        },
        id: this.formInline.id,
      };
      console.log(req);
      this.loading = true;
      let bool = await this.exhibitionIdPut(req).catch((err) => {
        this.loading = false;
      });
      if (!bool) {
        this.loading = false;
        this.$Message.error("修改失败，请重新尝试");
      } else {
        this.$emit("finish");
        this.$Message.success("修改成功！");
        this.cancel();
        this.loading = false;
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid);
        });
      });
    },
    cancel() {
      this.$refs["formInline"].resetFields();
      this.$emit("close");
    },
    dateChange(e) {
      this.exDate = e;
    },
    changeProvince(val) {
      // this.formInline.city = this.company.city || "";
      for (var i = 0; i < this.provinceArr.length; i++) {
        if (val == this.provinceArr[i].value) {
          this.citiesArr = this.provinceArr[i].children;
          this.countyArr = [];
        }
      }
    },
    changeCity(val) {
      for (var i = 0; i < this.citiesArr.length; i++) {
        if (val == this.citiesArr[i].value) {
          this.countyArr = this.citiesArr[i].children;
        }
      }
    },
  },
  components: {
    customComponentCommon,
  },
};
</script>

<style lang="scss">
.project-add {
  .ivu-radio {
    display: none;
  }
}
</style>
<style scoped lang="scss">
.project-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.project-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>

